import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatExpansionModule } from '@angular/material/expansion'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { ReactiveFormsModule } from '@angular/forms'
import { MatMenuModule } from '@angular/material/menu'

@Component({
	standalone: true,
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		MatExpansionModule,
		MatIconModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		ReactiveFormsModule,
		MatMenuModule,
	],
	selector: 'feature-porto-bank-cities',
	templateUrl: './cities.component.html',
	styleUrls: ['./cities.component.scss'],
})
export class CitiesComponent {
	static readonly ALL_CITIES = 'ALL_CITIES'
	ALL_CITIES = CitiesComponent.ALL_CITIES

	@Input() cities: string[] = []
	@Input() selectedCity?: string

	@Output() citySelected = new EventEmitter<string>()

	selectCity(city: string) {
		this.citySelected.emit(city)
	}
}
